import * as React from 'react';

interface ILabelProps {
    className: string;
    label?: string;
}

export const Label: React.FC<ILabelProps> = ({ className, label }) => <span className={className}>{label}</span>;

export default Label;
